import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'oms-list-item-simple-data',
  standalone: true,
  imports: [CommonModule, AvatarModule, ButtonModule],
  templateUrl: './list-item-simple-data.component.html',
  styleUrl: './list-item-simple-data.component.scss',
})
export class ListItemSimpleDataComponent {
  @Input() informationData!: string;
  @Input() greyTitle!: string;
  @Input() avatarIcon!: string;
  @Input() copiable: boolean = false;
  @Output() copyClicked = new EventEmitter<void>();

  handleCopy(): void {
    this.copyClicked.emit();
  }
}
